import { DatePipe } from '@angular/common'
import {
  ApplicationConfig,
  provideZoneChangeDetection,
  isDevMode,
} from '@angular/core'
import { CycDatePipe } from 'projects/tools/src/lib/cyc-date.pipe'
import { TimePipe } from 'projects/tools/src/lib/time.pipe'
import { provideServiceWorker } from '@angular/service-worker'
import { I18nModule } from 'projects/commons/src/lib/i18n.module'

export const appConfig: ApplicationConfig = {
  providers: [
    I18nModule.setLocale(),
    I18nModule.setLocaleId(),
    CycDatePipe,
    TimePipe,
    DatePipe,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
}
